import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Box, Button } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'dva';
import { useLocation, history } from 'umi';
import Alert from '@material-ui/core/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import GetAppIcon from '@material-ui/icons/GetApp';
import AddQrCode from './components/AddQrCode';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import AddQrCodeStyled from './AddQrCodeStyles';
import webStorage from '@/utils/storageManager';

export default () => {
  const submitRef = useRef();
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { id, isCopy, queryType, pathType, sourceType } = query;
  const { handleSubmit, control, setValue, watch, getValues, errors } =
    useForm();
  const { qrParamsFormData } = useSelector((state) => state.voucherEdit);
  const [isSubmit, setIsSubmit] = useState(false);
  //外部导入文件list
  const [fileList, setFileList] = useState([]);
  const [saveOpen, setSaveOpen] = useState({
    tips: '',
    status: false,
    title: '',
  });
  const [canDownload, setCanDownload] = useState(true);
  const [alertOpen, setAlertOpen] = useState(false);
  const [pagePath, setPagePath] = useState('');
  const watchAppId = watch('appId');
  const { QR_CODE_PATH_TYPE } = webStorage.get('DICTOBJ') || {};
  const { QR_CODE_SOURCE_TYPE } = webStorage.get('DICTOBJ') || {};
  useEffect(() => {
    // dispatch({
    //   type: 'voucherEdit/initQrParamsFormData',
    //   payload: {
    //     values: [{ name: 'act', value: id, id: guid() }],
    //   },
    // });
    const pt = QR_CODE_PATH_TYPE.find(
      (item) => String(item.dictValue) === pathType,
    )?.dictCode;
    watchAppId &&
      dispatch({
        type: 'voucherEdit/queryQrCodePagePath',
        payload: {
          values: {
            appId: watchAppId,
            type: pt,
          },
        },
        callback(res) {
          res && res.code === 0 && setPagePath(res.data.pagePath);
        },
      });
  }, [watchAppId, pathType]);

  //提交成功
  const handleSubmitSuccess = (data) => {
    if (isSubmit) {
      return false;
    }
    setIsSubmit(true);
    let qrParamsStatus = 0;
    const newQrParamsFormData = qrParamsFormData.filter(
      (item) => item.name || item.value,
    );
    newQrParamsFormData.forEach((item) => {
      if (item.name && !item.value) {
        qrParamsStatus = 1; //有id,没有内容
        return;
      } else if (!item.name && item.value) {
        qrParamsStatus = 2; //没有id,有内容
        return;
      }
    });
    if (qrParamsStatus === 1) {
      setIsSubmit(false);
      return window.message.toast({
        type: 'error',
        message: '参数内容不得为空',
        title: '错误',
      });
    } else if (qrParamsStatus === 2) {
      setIsSubmit(false);
      return window.message.toast({
        type: 'error',
        message: '参数名称不得为空',
        title: '错误',
      });
    }
    const newListLength = new Set(newQrParamsFormData.map((item) => item.name))
      .size;
    if (newQrParamsFormData?.length > newListLength) {
      setIsSubmit(false);
      return window.message.toast({
        type: 'error',
        message: '参数名称不可重复',
        title: '错误',
      });
    }
    const newQrParamsFormDataDeleteId =
      newQrParamsFormData?.length > 0
        ? newQrParamsFormData.map((item) => ({
            name: item.name,
            value: item.value,
          }))
        : [];
    const pt = QR_CODE_SOURCE_TYPE.find(
      (item) => String(item.dictValue) === sourceType,
    )?.dictCode;
    const values = {
      ...data,
      params: newQrParamsFormDataDeleteId,
      storeInfoList: null,
      activityId: id,
      isCopy,
      importUrl: fileList?.[0]?.url || null,
      importFileName: fileList?.[0]?.fileName || null,
      pagePath,
      activityType: pt,
      createType: '1',
    };
    dispatch({
      type: 'voucherEdit/saveQrCodeGroup',
      payload: {
        values,
      },
      callback: (code) => {
        if (code === 0) {
          window.message.toast({
            type: 'success',
            message: '保存成功',
            title: '成功',
          });
          setCanDownload(false);
          setIsSubmit(false);
        } else {
          setIsSubmit(false);
        }
      },
    });
  };
  //提交失败
  const handleSubmitFail = () => {
    setIsSubmit(false);
  };

  useEffect(() => {
    if (!id) {
      return false;
    }
    const pt = QR_CODE_SOURCE_TYPE.find(
      (item) => String(item.dictValue) === sourceType,
    )?.dictCode;
    dispatch({
      type: 'voucherEdit/getQueryQrCode',
      payload: {
        values: {
          id,
          activityType: pt,
          urlType: 1,
        },
      },
      callback: () => {},
    });
  }, [id, dispatch]);

  //获取公众号列表
  const fetchAppIdList = useCallback(() => {
    dispatch({
      type: 'addAutoReplyRule/getMiniProgramAccountList',
      payload: {
        values: {},
      },
      callback: (res) => {
        //初始默认选中第一个
        const data = res?.data || [];
        data.length > 0 && setValue('appId', data[0].appId);
      },
    });
  }, [dispatch, setValue]);
  useEffect(() => {
    fetchAppIdList();
  }, [fetchAppIdList]);

  const handleSubmitData = () => {
    // setOpenError(true);
    canDownload &&
      setSaveOpen({
        status: true,
        tips: '确认保存当前所创建的内容？',
        title: '保存',
      });
  };

  //新建标签自定义按钮
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
        }}
      >
        <Button
          sx={{
            width: '100px!important',
          }}
          variant="contained"
          onClick={onCloseDialog}
          color="secondary"
        >
          取消
        </Button>
        <Button
          sx={{ width: '100px!important' }}
          variant="contained"
          onClick={onSaveLabelDialog}
        >
          确定
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };
  const onCloseDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
  };

  const onSaveLabelDialog = () => {
    setSaveOpen({
      ...saveOpen,
      status: false,
    });
    if (saveOpen.title === '保存') {
      submitRef.current.click();
      return;
    }
    history.goBack();
  };
  const handleClickOpen = () => {
    if (!canDownload) {
      history.goBack();
      return;
    }
    canDownload &&
      setSaveOpen({
        status: true,
        tips: '退出后将不保存设置内容，确定要退出吗？',
        title: '退出',
      });
  };
  const handleDownData = () => {
    const pt = QR_CODE_SOURCE_TYPE.find(
      (item) => String(item.dictValue) === sourceType,
    )?.dictCode;
    dispatch({
      type: 'voucherEdit/downloadQRCode',
      payload: {
        values: {
          id,
          activityType: pt,
          envVersion: process.env.QRCODE_ENV_VERSION,
        },
      },
      callback(code) {
        if (code === 0) {
          setAlertOpen(true);
        }
      },
    });
  };
  const handleCloseAlert = () => {
    setAlertOpen(false);
  };

  return (
    <AddQrCodeStyled queryType={queryType}>
      <Box height="100%" className="qr-wrap">
        <Box
          borderRadius="4px"
          bgcolor="background.paper"
          pt={7}
          pr={7}
          pb={4}
          pl={7}
        >
          <form onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitFail)}>
            <AddQrCode
              control={control}
              setValue={setValue}
              watch={watch}
              getValues={getValues}
              errors={errors}
              setFileList={setFileList}
              fileList={fileList}
              setCanDownload={setCanDownload}
            />
            <Box display="flex" gap="0 4px" pt={6} className="button-wrap">
              {queryType !== 'detail' && (
                <Button
                  disabled={!canDownload}
                  variant="contained"
                  className="coupons-setting-button"
                  onClick={handleSubmitData}
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  完成
                </Button>
              )}
              <Button
                variant="contained"
                className="coupons-setting-button"
                color="secondary"
                onClick={handleClickOpen}
                startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
              >
                退出
              </Button>
              <Button
                variant="contained"
                className="coupons-setting-button"
                disabled={canDownload}
                onClick={handleDownData}
                startIcon={
                  <GetAppIcon sx={{ width: '16px', height: '16px' }} />
                }
              >
                下载
              </Button>
              <Button
                sx={{ display: 'none' }}
                type="submit"
                ref={submitRef}
              ></Button>
            </Box>
          </form>
        </Box>
      </Box>
      <DialogDataML
        open={saveOpen.status}
        title={
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <span
              style={{ fontSize: '18px', fontWeight: 600, color: '#212121' }}
            >
              {saveOpen.title}
            </span>
          </Box>
        }
        content={<Box sx={{ width: '336px' }}>{saveOpen.tips}</Box>}
        handleClose={onCloseDialog}
        button={initButton()}
      />
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
      >
        <Alert
          severity="info"
          sx={{
            width: '419px',
            backgroundColor: '#E5F6FD',
            fontSize: '14px',
            lineHeight: '22px',
          }}
          iconMapping={{
            info: <ErrorIcon fontSize="inherit" sx={{ color: '#2094D6' }} />,
          }}
        >
          数据下载中，可在我的任务查看下载结果
        </Alert>
      </Snackbar>
    </AddQrCodeStyled>
  );
};
